import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import SensorsOutlinedIcon from "@mui/icons-material/SensorsOutlined";
import DashboardLayout from "../../widgets/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../widgets/Navbars/DashboardNavbar";
import { PageContentShell, TabbedPage, type TabbedPageTab } from "../../components/layout";
import DefinitionListPage from "./ui/DefinitionListPage";
import IncidentListPage from "./ui/IncidentListPage";
import RunListPage from "./ui/RunListPage";
import PluginDetectorsPanel from "./ui/PluginDetectorsPanel";

/** Anomaly hub: definitions, incidents, runs and plugin detectors share one page (`?tab=`). */
const Anomalies = () => {
  const { t } = useTranslation();
  const tabs = useMemo<TabbedPageTab[]>(
    () => [
      {
        key: "definitions",
        label: t("anomaly.listTitle"),
        icon: <RuleOutlinedIcon fontSize="small" />,
        render: () => <DefinitionListPage />,
      },
      {
        key: "incidents",
        label: t("anomaly.incidents"),
        icon: <NotificationImportantOutlinedIcon fontSize="small" />,
        render: () => <IncidentListPage />,
      },
      {
        key: "runs",
        label: t("anomaly.runs"),
        icon: <HistoryOutlinedIcon fontSize="small" />,
        render: () => <RunListPage />,
      },
      {
        key: "detectors",
        label: t("anomaly.pluginDetector"),
        icon: <SensorsOutlinedIcon fontSize="small" />,
        render: () => <PluginDetectorsPanel />,
      },
    ],
    [t]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageContentShell>
        <TabbedPage title={t("anomaly.title")} tabs={tabs} />
      </PageContentShell>
    </DashboardLayout>
  );
};

export default Anomalies;
